import { useLazyQuery } from '@apollo/client';
import { Data } from '../models/dealer';
import { BY_ADDRESS } from '../utils/graphql/dealers';
import { toISO3CountryCode } from '../utils/i18n';

export default function useLazySearchByAddress(
  text: string,
  radiusInKm: number,
  countryCode?: string,
  filters?: string[],
  userLat?: number,
  userLng?: number,
) {
  const [load, { error, loading, data }] = useLazyQuery<
    Data,
    {
      searchTerm: string;
      radius: number;
      userLat?: number;
      userLng?: number;
      country?: string;
      services?: string;
    }
  >(BY_ADDRESS, { fetchPolicy: 'network-only' });

  const loadDealers = () => {
    if (text?.length) {
      load({
        variables: {
          searchTerm: text,
          radius: radiusInKm,
          ...(countryCode && {
            country: toISO3CountryCode(countryCode),
          }),
          ...(filters?.length && { services: filters.join() }),
          userLat,
          userLng,
        },
      });
    }
  };

  return {
    loadDealers,
    error,
    loading,
    dealersResult: data?.dealersByAddress?.dealers,
  };
}
